module.exports = __webpack_public_path__ + "img/txtennova_logotype.177e6415.svg";